// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Styles for exit impersonation confirmation modal */", "",{"version":3,"sources":["webpack://./src/app/components/exit-impersonation-confirm-modal/exit-impersonation-confirm-modal.component.scss"],"names":[],"mappings":"AAAA,qDAAA","sourcesContent":["/* Styles for exit impersonation confirmation modal */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
